export const userDropdown = {
  userProfile: 'My Profile',
  userOrders: 'My Orders',
  userData: 'Personal Data',
  userAddress: 'My Addresses',
  logOut: 'Log out',
  logIn: 'Log in',
};

export const userData = {
  register: 'Register',
  registerHeader: {
    step1: 'Create account',
    step2: 'Add data',
    step3: 'Confirmation',
  },
  registerDescription: 'Now provide your name and contact details. You can change this later under "My account".',
  registerConfirmationFallback: 'Your registration was successful. You can now discover the variety of the assortment at DER GRISSEMANN online shop!',
  registerNoUser: 'Server error, please try again later.',
  personalData: 'Personal data',
  changePassword: 'Change password',
  edit: 'Edit personal data',
  shoppingCart: 'Shopping Cart',
  salutation: 'Salutation',
  salutationValue: {
    mr: 'Mr.',
    mrs: 'Ms.',
  },
  order: {
    orderWithNr: 'Order {orderId}',
    orderDate: 'on {date}',
    orderValue: 'Order value',
    back: 'Back to my orders',
  },
  firstName: 'First Name',
  lastName: 'Last Name',
  email: 'Email',
  birthDate: 'Birth Date',
  company: 'Company',
  address: 'Address',
  pageSize: 'Products per page',
  addressData: {
    title: 'Your Addresses',
    countryCode: 'Country Code',
    postCode: 'Post Code',
    city: 'City',
    street: 'Street',
    streetNr: 'No.',
    company: 'Company',
    empty: 'There are currently no addresses associated with your account',
    telephone: 'Telephone',
    email: 'Email address',
    birthday: 'Birthday',
    loading: 'Loading',
  },
  megaCard: {
    choice: {
      reject: 'I don\'t want a MegaCard',
      rejectDetail: 'If you change your mind, you can always request or add a MegaCard from your profile later.',
      want: 'I want a MegaCard',
      wantDetail: 'We\'ll send you a MegaCard to the address you enter below.',
      have: 'I have a MegaCard',
      haveDetail: 'When you connect your MegaCard, your personal data will automatically be applied. Of course, ' +
        'you will still be able to change it.',
    },
    title: 'My MegaCard',
    number: 'MegaCard Number',
    postCode: 'Post code',
    actionConnect: 'Check',
    actionDisconnect: 'Undo',
    pleaseChoose: 'Please choose:',
    noChoice: 'Please indicate above whether you own a MegaCard.',
    register: {
      connectSuccess: 'Thanks, {successName}! Your MegaCard has been connected and your personal data is ' +
        'pre-filled below.',
      connectUnknown: 'We were unable to find a MegaCard with this data. You can also add your MegaCard in your ' +
        'profile later.',
      connectError: 'An error occurred obtaining your MegaCard information. You can also add your MegaCard in ' +
        'your profile later.',
    },
    profile: {
      connectSuccess: 'Thanks, {successName}! Please confirm the connection by clicking "Connect" below. ' +
        'Please note that the connection cannot be modified later.',
      connectUnknown: 'We were unable to find a MegaCard with this data. Feel free to call us if you need ' +
        'assistance.',
      connectError: 'An error occurred obtaining your MegaCard information. Please try again later.',
      connectHint: 'To connect your MegaCard, please enter your MegaCard number here. You will find it on the ' +
        'front of your card, just below the barcode. Please also enter your post code for verification.',
      hasInfo: 'You account is connected to MegaCard number {number} (post code: {postCode}).',
      teaser: 'Did you know that you can profit with every purchase using {infoLink}?',
      infoLink: 'our MegaCard loyalty card',
      actionOrder: 'Order MegaCard',
      actionConnect: 'Connect MegaCard',
    },
  },
  standardBilling: 'Default Billing Address',
  standardDelivery: 'Default Delivery Address',
  setStandardBilling: 'Set as default billing address',
  setStandardDelivery: 'Set as default delivery address',
};

export const lists = {
  brand: {
    singular: 'Shopping list',
    plural: 'Shopping lists',
  },
  myLists: {
    title: 'My Shopping lists',
    addNew: 'Create new list',
    addAllToCart: 'Add all items to cart',
    empty: 'You have not added any products to your shopping list.',
    delete: 'Delete shopping list',
    deleteWarning: 'Your shopping list will be irrevocably deleted.',
    noLists: 'You have not created a shopping list yet.',
    cartItems: 'currently in cart',
  },
  popup: {
    edit: 'Edit shopping lists',
    addTo: 'should be added to the following lists',
    addNew: 'Add new list',
    openPopup: 'Add to shopping lists',
  },
};

export const cart = {
  resumeShopping: 'Resume shopping',
  emptyCart: 'Empty shopping cart',
  emptyCartWarning: 'Your items in the shopping cart will be irrevocably deleted.',
  yourCart: 'Your shopping cart',
  products: 'Products',
  cartIsEmpty: 'Your shopping cart is empty.',
  otherCategory: 'Other',
  labels: {
    product: 'Product',
    singlePrice: 'Single price',
    positionPrice: 'Position price',
    amount: 'Amount',
  },
  checkout: {
    address: {
      billing: 'Billing address',
      delivery: 'Delivery address',
      deliverySeparate: 'Differing delivery address',
    },
  },
  summary: {
    discount: 'Discounts',
    value: 'Sum',
    totalPriceWithTax: 'Total price (incl. tax)',
    checkout: 'Proceed to checkout',
    itemsValue: 'Items value',
    shippingFees: 'Shipping fee',
    plus: 'plus',
    deposit: 'Deposits',
    noShippingFee: 'Not chosen',
    minValueReached: 'Minimum order value of {minValue} € reached',
    minValueNotReached: '{difference} € more to reach the Minimum order value of {minValue} €',
    coupon: 'Coupon',
    couponRedeem: 'Redeem coupon',
    couponError: 'Coupon invalid',
  },
  add: 'Add to cart',
  remove: 'Remove',
};
